import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { AdminRepository } from '@front/repository/Api/Admin';
import type { IAdminRepository } from '@front/repository/Api/Admin/interface';
import { useMutation } from '@tanstack/react-query';

const repository = new AdminRepository();

export const _forceFinishImportTask = () => {
  return useMutation({
    mutationFn: async (params: IAdminRepository.ForceFinishImportTask.Params) => {
      return repository.forceFinishImportTask(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    ...UseMutationDefaultOptions,
  });
};
